import { Box, Divider, Theme, Typography } from "@mui/material";
import { EquipmentTone } from "./EquipmentBox";

const LEGEND_COLOR: Record<EquipmentTone, (t: Theme) => string> = {
	ok: (t) => t.palette.success.main,
	alert: (t) => t.palette.error.main,
	warn: (t) => t.palette.warning.main,
	info: (t) => t.palette.info.main,
	cleaning: () => "#9C27B0",
	disabled: () => "#616161",
	unknown: () => "#fff",
};

const LegendItem = ({
	tone,
	label,
}: {
	tone: EquipmentTone;
	label: string;
}) => (
	<Box sx={{ display: "flex", alignItems: "center", gap: 0.6 }}>
		<Box
			sx={{
				width: 12,
				height: 12,
				borderRadius: 0.5,
				backgroundColor: LEGEND_COLOR[tone],
				border: tone === "unknown" ? "1px dashed #BDBDBD" : "none",
				flexShrink: 0,
			}}
		/>
		<Typography sx={{ fontSize: "0.7rem", color: "#555", lineHeight: 1.2 }}>
			{label}
		</Typography>
	</Box>
);

const LegendColumn = ({
	flex,
	items,
}: {
	flex: number;
	items: { tone: EquipmentTone; label: string }[];
}) => (
	<Box sx={{ flex, minWidth: 0 }}>
		<Box
			sx={{
				display: "flex",
				flexWrap: "wrap",
				rowGap: 0.2,
				columnGap: 0.8,
			}}
		>
			{items.map((it) => (
				<LegendItem key={it.label} tone={it.tone} label={it.label} />
			))}
		</Box>
	</Box>
);

export const EquipmentLegend = () => (
	<Box
		sx={{
			mt: 0.5,
			pt: 0.5,
			borderTop: "1px dashed #e0e0e0",
			display: "flex",
			alignItems: "stretch",
			gap: 1,
		}}
	>
		<LegendColumn
			flex={1.7}
			items={[
				{ tone: "ok", label: "Welding" },
				{ tone: "info", label: "Idle" },
				{ tone: "alert", label: "Alarm" },
				{ tone: "unknown", label: "No data" },
			]}
		/>
		<Divider orientation="vertical" flexItem />
		<LegendColumn
			flex={2.2}
			items={[
				{ tone: "ok", label: "Closed" },
				{ tone: "alert", label: "Open" },
				{ tone: "unknown", label: "No data" },
			]}
		/>
		<Divider orientation="vertical" flexItem />
		<LegendColumn
			flex={1.8}
			items={[
				{ tone: "ok", label: "OK" },
				{ tone: "alert", label: "E-Stop" },
				{ tone: "unknown", label: "No data" },
			]}
		/>
		<Divider orientation="vertical" flexItem />
		<LegendColumn
			flex={2.5}
			items={[
				{ tone: "ok", label: "OK / Enabled" },
				{ tone: "cleaning", label: "Cleaning" },
				{ tone: "disabled", label: "Disabled" },
				{ tone: "warn", label: "Warning" },
				{ tone: "alert", label: "Alarm" },
				{ tone: "unknown", label: "No data" },
			]}
		/>
	</Box>
);
